import { render, staticRenderFns } from "./TableSkeletonLoader.vue?vue&type=template&id=6729995c"
import script from "./TableSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./TableSkeletonLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports